import { render, staticRenderFns } from "./manageCategory.vue?vue&type=template&id=4e600085&scoped=true&"
import script from "./manageCategory.vue?vue&type=script&lang=js&"
export * from "./manageCategory.vue?vue&type=script&lang=js&"
import style0 from "./manageCategory.vue?vue&type=style&index=0&id=4e600085&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e600085",
  null
  
)

export default component.exports